import { withErrorBoundary } from 'shared'

const PaymentResponsePage = () => {
  return <div className="row">
    <h1>Payment Successful</h1>
  </div>
}
export default withErrorBoundary(PaymentResponsePage)
